module.exports = __webpack_public_path__ + "img/googlecloud.ec716c35.jpg";